var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded-full mr-1 mb-1 pl-1 pr-1 bg-primary-50 dark:bg-darkblue text-primary border-2 tag-cell"},[_vm._v(" "+_vm._s(_vm.tagName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }